import { Button, dialog } from "nq-component";
import CardView from "../../../../components/common/CardView";
import { FloatingForm } from "../../../../components/common/Converter";
import BaseFormPage from "../../../../base/BaseFormPage";
import { upsertUseCase, findObjectUseCase } from "../../../../usecases/object";
import { createNotification } from "../../../../createNotification";
import FormFactory from "../../../../components/FormFactory";
import RequestOvertimePresenter from "./RequestOvertimePresenter";
export default class RequestOvertime extends BaseFormPage {
  constructor(props) {
    super(props);
    this.presenter = new RequestOvertimePresenter(this);
    this.state = {
      object: {},
    };
  }

  componentDidMount() {
    this.presenter.componentDidMount();
    const employeeName = `${this.props.object?.employee?.Firstname || ""} ${
      this.props.object?.employee?.Middlename || ""
    } ${this.props.object?.employee?.surname || ""}`;
    this.setState({ object: this.props.object, employeeName });
    return;
  }

  dialogClose() {
    dialog.close();
  }

  calculateOvertimeDuration(startTime, endTime) {
    // Combine date and time strings into Date objects
    const startDateTime = new Date(startTime);
    const endDateTime = new Date(endTime);

    // Calculate the difference in milliseconds
    const diffInMs = endDateTime - startDateTime;

    // Convert the difference to hours and minutes
    const diffInMinutes = Math.floor(diffInMs / 60000);
    const hours = Math.floor(diffInMinutes / 60);
    const minutes = diffInMinutes % 60;

    return `${hours} hours and ${minutes} minutes`;
  }

  async handleApproveBtn() {
    this.submitData("Approved");
  }
  async handleRejectBtn() {
    this.submitData("Rejected");
  }

  async confirmChanges() {
    this.submitData("Pending");
  }

  async submitData(status) {
    const { object } = this.state;
    const empID = this.getCurrentUser().employee;
    const employee = await findObjectUseCase().execute("employees", {
      where: { id: empID.id },
    });

    const duration = this.calculateOvertimeDuration(
      object.startTime,
      object.endTime
    );

    const noSupervisorAssigned = employee.every((emp) => !emp.supervisor);
    if (noSupervisorAssigned) {
      this.showError("No Supervisor Assigned");
      return;
    }

    object.duration = duration;
    object.employee = { id: empID.id };
    object.supervisor = { id: employee[0].supervisor.id };
    object.stats = status;

    if (object?.id) {
      await upsertUseCase().execute("overtime", object);

      this.props.closeAccess();
      this.props.refetchData();
      this.showSuccess("Success");

      //  CREATE NOTIFICATION
      let NOTIFICATION_MESSAGE = "Your Overtime Request has been approved!";
      if (status === "Rejected") {
        NOTIFICATION_MESSAGE = "Your Overtime Request has been rejected!";
      }
      const NOTIFICATION_RECEIVER = [object.employee.id];
      const NOTIFICATION_REDIRECT = "overtime";

      createNotification(
        NOTIFICATION_MESSAGE,
        NOTIFICATION_RECEIVER,
        NOTIFICATION_REDIRECT
      );
    } else {
      await upsertUseCase().execute("overtime", object);

      this.dialogClose();
      this.props.closeAccess();
      this.props.refetchData();
      this.showSuccess("Success");

      //  CREATE NOTIFICATION
      const NOTIFICATION_MESSAGE = "You have a new Overtime awaiting review.";
      const NOTIFICATION_RECEIVER = [object.supervisor.id];
      const NOTIFICATION_REDIRECT = "overtimes";

      createNotification(
        NOTIFICATION_MESSAGE,
        NOTIFICATION_RECEIVER,
        NOTIFICATION_REDIRECT
      );
    }
  }

  handleClickOk() {
    dialog.fire({
      html: (
        <div className="p-2">
          <div className="row">
            <h4>Submit Request Confirmation</h4>
            <hr />
            <p style={{ fontSize: "13px", padding: "1rem" }}>
              Click confirm to proceed.
            </p>
            <hr />
          </div>

          <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={this.dialogClose.bind(this)}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={this.confirmChanges.bind(this)}
            >
              Confirm
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }

  getCollectionName() {
    return "overtime";
  }

  render() {
    const isDisabled =
      this.props.isForViewing && this.props.object.stats !== "";
    const schema = this.getSchema(this.getCollectionName());
    return (
      <>
        <FloatingForm width="30rem">
          <CardView style={{ padding: 0 }}>
            <h4 className="fs-5 fw-bold pt-3 ps-3">Overtime Request Details</h4>
            <hr />

            {this.props.isAdmin && (
              <label className="p-4">
                <b>Employee: </b> {this.state.employeeName}
              </label>
            )}
            <form
              onSubmit={(e) => {
                e.preventDefault();
                this.handleClickOk();
              }}
            >
              <div className="w-100" style={{ padding: "0 1rem" }}>
                <div className="w-100">
                  <div className="row p-2">
                    <FormFactory
                      className="col-lg-12 p-1"
                      schema={schema}
                      object={this.state.object}
                      disabled={this.props.object.id}
                      onChange={this.onChange.bind(this)}
                      min={this.state.object?.startTime}
                      excludeFields={[
                        "stats",
                        "duration",
                        "employee",
                        "supervisor",
                      ]}
                    />
                  </div>
                </div>
              </div>
              <hr />
              <div className="w-100 d-flex justify-content-end gap-2 mb-3 pe-3">
                <Button
                  className="btn btn-light fs-sm"
                  type="button"
                  onClick={() => this.props.closeAccess()}
                >
                  Cancel
                </Button>
                {!isDisabled && !this.props.isAdmin && (
                  <Button type="submit" className="btn btn-primary">
                    Submit Request
                  </Button>
                )}

                {this.props.isAdmin && (
                  <>
                    {this.props.object.stats === "Pending" && (
                      <>
                        <Button
                          type="button"
                          onClick={this.handleApproveBtn.bind(this)}
                          className="btn btn-primary"
                        >
                          Approve
                        </Button>
                        <Button
                          type="button"
                          onClick={this.handleRejectBtn.bind(this)}
                          className="btn btn-danger"
                        >
                          Reject
                        </Button>
                      </>
                    )}
                  </>
                )}
              </div>
            </form>
          </CardView>
        </FloatingForm>
      </>
    );
  }
}
